module.exports = __webpack_public_path__ + "static/media/online-king.8c6d5f26.png";